import { PulsingButton } from '../../components/Button';
import { FlexLayout, FlexView } from '../../components/layout/Flex';
import { GitHubIcon } from '../../assets/visual/png/icons';
import { Cover } from '../../components/Text';

const Outro = () => {
	return (
		<FlexLayout>
			<FlexView
				style={{
					padding: '150px 5%',
				}}
			>
				<Cover style={{ maxWidth: '200px' }}>Get To Know Me More </Cover>
			</FlexView>
			<FlexView
				style={{
					alignItems: 'end',
					justifyContent: 'center',
					padding: '5% 0 7%',
				}}
			>
				<div>
					<PulsingButton href="https://github.com/100pearlcent">
						<img
							src={GitHubIcon}
							width="100vw"
							height="auto"
							alt="GitHubButton"
						/>
					</PulsingButton>
				</div>
			</FlexView>
		</FlexLayout>
	);
};

export default Outro;
